export default __webpack_public_path__ + "assets/salomao-zoppi-component.52c4877f.svg";